var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-align-center"},[_c('img',{attrs:{"src":_vm.vehicleIcon,"alt":_vm.vehicleAltText,"width":"80"}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c345fb2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/app/components/VehicleIcon.vue
// module id = pOXG
// module chunks = 1